import okiPersonalForm from './oki-personal-form/oki-personal-form.vue';
import { mapState, mapActions } from 'vuex';
import store from '../../../common/js/vuex/oki-store';
import offset from 'document-offset';
import { HEADER_HEIGHT, ROUTE_NAMES, DEBUG } from '../constants/oki-constants';
const SCROLL_TO_REFS = ['personal-data-title', 'personal-data-title', 'contact', 'branch-selector'];
const TA_CODES = {
	OKI: {
		nextButtonSave: 'OKI_SZEMELYES_ADATOK_TOVABB',
		progressBarNavigation: 'OKI_SZEMELYES_ADATOK_ADATOK_SZERKESZTEM'
	},
	SOKI: {
		nextButtonSave: 'SOKI_SZEMELYES_ADATOK_TOVABB',
		progressBarNavigation: 'SOKI_SZEMELYES_ADATOK_ADATOK_SZERKESZTEM'
	}
};
export default {
	data() {
		return {
			previousEmployeeStatus: null,
			postInProgress: false,
			hasClaimCodeChanged: false
		};
	},
	components: {
		okiPersonalForm
	},
	computed: {
		...mapState({
			bankBranches: (state) => state.personal.bankBranches,
			birthPlaces: (state) => state.personal.birthPlaces,
			personalData: (state) => state.personal.personalData,
			settlements: (state) => state.personal.settlements.map((settlement) => settlement.name)
		}),
		...mapState(['soki', 'mobileProviders', 'counties', 'districts', 'captcha', 'captchaError', 'cardData']),
		isMobile() {
			return this.$resize && this.$mq.below(767);
		}
	},
	methods: {
		postData(model) {
			this.postInProgress = true;
			let okiSoki = this.soki ? 'SOKI' : 'OKI';
			model.taEvent = this.saveFromProgressBar ? TA_CODES[okiSoki].progressBarNavigation : TA_CODES[okiSoki].nextButtonSave;
			this.postPersonalForm(model).then(() => {
				if (!this.saveFromProgressBar) {
					this.$router.push(ROUTE_NAMES.KARTYAESSZAMLA);
				}
				this.saveFromProgressBar = false;
			});
		},
		...mapActions(['getSettlements', 'bankBranchSearch', 'lookupBirthPlaces', 'resetBirthPlaces', 'postPersonalForm', 'rememberPersonalData']),
		onHasClaimCodeChange(hasClaimCodeChanged) {
			this.hasClaimCodeChanged = hasClaimCodeChanged;
			if (this.hasClaimCodeChanged) {
				store.dispatch('removeValidPages', ROUTE_NAMES.KARTYAESSZAMLA);
				store.dispatch('removeVisitedPages', ROUTE_NAMES.KARTYAESSZAMLA);
				store.dispatch('removeValidPages', ROUTE_NAMES.KARTYAKEP);
				store.dispatch('removeVisitedPages', ROUTE_NAMES.KARTYAKEP);
				store.dispatch('removeValidPages', ROUTE_NAMES.OSSZEGZES);
				store.dispatch('removeVisitedPages', ROUTE_NAMES.OSSZEGZES);
				store.dispatch('clearFinancialInputFields');
			}
		}
	},
	beforeRouteLeave(to, from, next) {
		this.$nextTick(() => {
			if (this.$refs.form.isValid() || DEBUG) {
				store.dispatch('addValidPages', from.path);
				let model = this.$refs.form.convertToBackendModel();
				if (!this.postInProgress) {
					this.saveFromProgressBar = true;
					this.postData({ personalData: model });
				}
				next();
			} else if (DEBUG || from.fullPath == store.state.visitedPages[store.state.visitedPages.length - 1]) {
				let model = this.$refs.form.convertToBackendModel();
				this.rememberPersonalData(model);
				next();
			} else {
				store.dispatch('removeValidPages', from.path);
				next(false);
				this.$nextTick(() => {
					let elem = document.querySelector('.has-error');
					this.$scrollTo(elem, { duration: 500 });
				});
			}
			this.postInProgress = false;
		});
	},
	beforeRouteEnter(to, from, next) {
		store.dispatch('setCurrentPage', to.path);
		store.dispatch('addVisitedPages', to.path);
		next();
	},
	mounted() {
		setTimeout(() => {
			if (this.$route.query.id) {
				let elem = this.$refs.form.$refs[SCROLL_TO_REFS[this.$route.query.id]];
				this.$scrollTo(elem, { duration: 500 });
				elem.focus();
			} else {
				if (!this.isMobile) {
					let elem = document.querySelector('#oki-progress-bar');
					window.scroll(0, elem && offset(elem).top ? offset(elem).top : 0);
				} else {
					window.scroll(0, offset(this.$el).top - HEADER_HEIGHT);
				}
				if (this.$refs.form && this.$refs.form.$refs && this.$refs.form.$refs && this.$refs.form.$refs[SCROLL_TO_REFS[0]]) {
					this.$refs.form.$refs[SCROLL_TO_REFS[0]].focus();
				}
			}
		});
	}
};
